import {textRequest, jsonRequest, isDefined, GET, POST} from "./helpers";

export const getWorkflow = async (id) => {
  if (!isDefined(id)) throw new Error("Cannot get workflow - Missing required property");
  return await jsonRequest(GET, `Workflows/${id}`);
};

export const runWorkflow = async (workflowName, uploadId, parentProcessId, language, additionalNotes,
  createTranslation
) => {
  if (!isDefined(uploadId) || !workflowName) {
    throw new Error("Cannot run workflow - Missing required property");
  }
  const data = {
    uploadId,
  };
  if (isDefined(parentProcessId)) data.parentProcessId = parentProcessId;
  if (isDefined(language)) data.language = language;
  if (isDefined(additionalNotes)) data.additionalNotes = additionalNotes;
  if (isDefined(createTranslation)) data.createTranslation = createTranslation;
  console.log("runWorkflow data =", data);
  return await textRequest(POST, `Workflows/${workflowName}`, {
    body: JSON.stringify(data),
  });
};
